/* eslint-disable no-unreachable */
import React, { useEffect, useContext, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import Select from 'react-select';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import useFormValidator from 'useFormValidator';
import DateInputPicker from 'modules/common/components/DateInputPicker';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import Region from 'modules/common/address/Region';
import Province from 'modules/common/address/Province';
import Municipality from 'modules/common/address/Municipality';
import CmsContext from 'context/CmsContext';
import { reactSelectCustomStyle } from 'helper';
import * as actions from '../action';
import * as c from '../constant';

function BirthCertModal({
  createBirthCertificate,
  getBirthCertificateList,
  history,
  showBirthCertificate,
  getRoleList,
  creating,
  recordData,
  updating,
  syncing,
  updateBirthCertificate,
  syncToEs,
}) {
  const cmsContext = useContext(CmsContext);
  const CMS_VARIABLES = cmsContext.findByType('VARIABLES');

  const [formData, setFormData] = useState({
    registry_number: '',
    last_name: '',
    first_name: '',
    birth_place: '',
    birth_date: '',
    mothers_last_name: '',
    mothers_first_name: '',
    sex: '',
  });

  const commonValidation = {
    registry_number: 'required',
    last_name: 'required',
    first_name: 'required',
    birth_place: 'required',
    birth_date: 'required',
    mothers_last_name: 'required',
    mothers_first_name: 'required',
    sex: 'required',
  };

  const validateForm = useFormValidator(formData, commonValidation);

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  const setModal = useContext(ModalContext);

  useEffect(() => {
    if (recordData) {
      setFormData({
        ...c.FORM_DATA,
        registry_number: _.get(recordData, 'attributes.registry_number') || '',
        first_name: _.get(recordData, 'attributes.first_name') || '',
        middle_name: _.get(recordData, 'attributes.middle_name') || '',
        last_name: _.get(recordData, 'attributes.last_name') || '',
        extension_name: _.get(recordData, 'attributes.extension_name') || '',
        birth_date: _.get(recordData, 'attributes.birth_date') || '',
        sex: _.get(recordData, 'attributes.sex') || '',
        volume: _.get(recordData, 'attributes.volume') || '',
        place_of_birth_municipality_code:
          _.get(recordData, 'attributes.place_of_birth_municipality_code') ||
          '',
        mothers_first_name:
          _.get(recordData, 'attributes.mothers_first_name') || '',
        mothers_middle_name:
          _.get(recordData, 'attributes.mothers_middle_name') || '',
        mothers_last_name:
          _.get(recordData, 'attributes.mothers_last_name') || '',
        mothers_extension_name:
          _.get(recordData, 'attributes.mothers_extension_name') || '',
      });
      return;
    }
    setFormData({
      ...c.FORM_DATA,
      place_of_birth_municipality_code:
        _.get(CMS_VARIABLES, 'MUNICIPALITY_CODE') || '',
    });
  }, [recordData]);

  const handleOnChangeDate =
    (key) =>
    ({ target: { value } }) => {
      setFormData({
        ...formData,
        [key]: value,
      });
    };

  const handleOnSubmitAdd = (e) => {
    e.preventDefault();

    const args = {
      ...formData,
      registry_number: formData.registry_number.toUpperCase(),
      last_name: formData.last_name.toUpperCase(),
      first_name: formData.first_name.toUpperCase(),
      // birth_place: formData.birth_place.toUpperCase(),
      birth_date: formData.birth_date.toUpperCase(),
      mothers_last_name: formData.mothers_last_name.toUpperCase(),
      mothers_first_name: formData.mothers_first_name.toUpperCase(),
    };

    createBirthCertificate(args, ({ data }) => {
      setModal({ isOpen: false });
      getBirthCertificateList();
      history.push(
        `/civil-registry/birth-certificate/records-maintenance/${_.get(
          data,
          'id'
        )}`
      );
      showBirthCertificate(data.id);
    });
  };

  const handleOnSubmitUpdate = (e) => {
    e.preventDefault();

    const args = {
      ...formData,
      registry_number: formData.registry_number.toUpperCase(),
      last_name: formData.last_name.toUpperCase(),
      first_name: formData.first_name.toUpperCase(),
      // birth_place: formData.birth_place.toUpperCase(),
      birth_date: formData.birth_date.toUpperCase(),
      mothers_last_name: formData.mothers_last_name.toUpperCase(),
      mothers_first_name: formData.mothers_first_name.toUpperCase(),
    };

    updateBirthCertificate(_.get(recordData, 'id'), args, ({ data }) => {
      getBirthCertificateList();
      setModal({ isOpen: false });
      showBirthCertificate(_.get(recordData, 'id'));
      syncToEs({ id: _.get(recordData, 'id') });
      history.push(
        `/civil-registry/birth-certificate/records-maintenance/${_.get(
          data,
          'id'
        )}`
      );
      // UpdateInfo();
    });
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  useEffect(() => {
    getRoleList();
  }, []);

  const handleOnChangeSelect = (e, key) => {
    setFormData({
      ...formData,
      [key]: e.value,
    });
  };

  const onChange = (e) => {
    return setFormData({
      ...formData,
      [e.target.name]:
        e.target.type === 'checkbox' ? e.target.checked : e.target.value,
    });
  };

  return (
    <Modal.Body>
      <form
        onSubmit={(e) =>
          !recordData ? handleOnSubmitAdd(e) : handleOnSubmitUpdate(e)
        }
      >
        <div className="">Document&apos;s Owner Personal Information</div>
        <div className="border border-primary m-1 p-1">
          <div className="row m-1 p-1">
            <div className="col-4 form-group">
              <label htmlFor="last_name" className="form-label mb-1">
                Registry Number &nbsp;{' '}
                {validateForm.renderMessage('registry_number')}
              </label>
              <input
                className="form-control text-uppercase"
                type="text"
                name="registry_number"
                onChange={onChange}
                value={_.get(formData, 'registry_number') || ''}
              />
            </div>
            <div className="col-4 form-group">
              <label htmlFor="last_name" className="form-label mb-1">
                First Name &nbsp; {validateForm.renderMessage('first_name')}
              </label>
              <input
                className="form-control text-uppercase"
                type="text"
                name="first_name"
                onChange={onChange}
                value={_.get(formData, 'first_name') || ''}
              />
            </div>
            <div className="col-4 form-group">
              <label htmlFor="last_name" className="form-label mb-1">
                Middle Name
              </label>
              <input
                className="form-control text-uppercase"
                type="text"
                name="middle_name"
                onChange={onChange}
                value={_.get(formData, 'middle_name') || ''}
              />
            </div>
          </div>
          <div className="row m-1 p-1">
            <div className="col-4 form-group">
              <label htmlFor="last_name" className="form-label mb-1">
                Last Name &nbsp; {validateForm.renderMessage('last_name')}
              </label>
              <input
                className="form-control text-uppercase"
                type="text"
                name="last_name"
                onChange={onChange}
                value={_.get(formData, 'last_name') || ''}
              />
            </div>
            <div className="col-4 form-group">
              <label className="form-label mb-1">Extension Name:</label>
              <Select
                className="extension_select"
                options={c.EXTENSION_NAMES}
                onChange={(e) => handleOnChangeSelect(e, 'extension_name')}
                value={
                  c.EXTENSION_NAMES.find(
                    (x) => x.value === _.get(formData, 'extension_name')
                  ) || null
                }
              />
            </div>
            <div className="col-4 form-group">
              <label className="form-label mb-1">
                Date of Birth: &nbsp; {validateForm.renderMessage('birth_date')}
              </label>
              <DateInputPicker
                className="full-input"
                onChange={handleOnChangeDate('birth_date')}
                value={_.get(formData, 'birth_date') || ''}
                maxDate={new Date()}
              />
            </div>
            <div className="col-4 form-group">
              <label className="form-label mb-1">
                Sex: {validateForm.renderMessage('sex')}
              </label>
              <Select
                className="extension_select"
                options={c.GENDER}
                onChange={(e) => handleOnChangeSelect(e, 'sex')}
                value={
                  c.GENDER.find((x) => x.value === _.get(formData, 'sex')) ||
                  null
                }
              />
            </div>
            <div className="col-4 form-group" />
            <div className="col-4 form-group" />

            <div className="form-input-group col-sm-12 col-md-6 col-lg-4">
              <label className="full-label mb-0 ">
                Place of Birth
                <br />
                Region
              </label>
              <Region
                isDisabled
                styles={reactSelectCustomStyle}
                // name="region_code"
                value={_.get(CMS_VARIABLES, 'REGION_CODE') || ''}
                onChange={() => {}}
              />
            </div>
            <div className="form-input-group col-sm-12 col-md-6 col-lg-4 mt-auto">
              <label className="full-label mb-0">Province</label>
              <Province
                isDisabled
                styles={reactSelectCustomStyle}
                // name="province_code"
                value={_.get(CMS_VARIABLES, 'PROVINCE_CODE') || ''}
                regionCode={_.get(CMS_VARIABLES, 'REGION_CODE') || ''}
                onChange={() => {}}
              />
            </div>
            <div className="form-input-group col-sm-12 col-md-6 col-lg-4 mt-auto">
              <label className="full-label mb-0">City/Municipality</label>
              <Municipality
                isDisabled
                styles={reactSelectCustomStyle}
                name="place_of_birth_municipality_code"
                value={
                  _.get(formData, 'place_of_birth_municipality_code') || ''
                }
                regionCode={_.get(CMS_VARIABLES, 'REGION_CODE') || ''}
                provinceCode={_.get(CMS_VARIABLES, 'PROVINCE_CODE') || ''}
                onChange={() => {}}
              />
            </div>
          </div>
        </div>
        <div className="mt-3">Owner&apos;s Family Information</div>
        <div className="mt-1">
          <label htmlFor="last_name" className="form-label mb-1">
            Mother&apos;s Maiden Name
          </label>
        </div>
        <div className="border border-primary row m-1 pt-2 mb-3">
          <div className="col-12">
            <div className="row">
              <div className="col-6 form-group">
                <label htmlFor="last_name" className="form-label mb-1">
                  Mother&apos;s First Name &nbsp;{' '}
                  {validateForm.renderMessage('mothers_first_name')}
                </label>
                <input
                  className="form-control text-uppercase"
                  type="text"
                  name="mothers_first_name"
                  onChange={onChange}
                  value={_.get(formData, 'mothers_first_name') || ''}
                />
              </div>
              <div className="col-6 form-group">
                <label htmlFor="last_name" className="form-label mb-1">
                  Mother&apos;s Middle Name
                </label>
                <input
                  className="form-control text-uppercase"
                  type="text"
                  name="mothers_middle_name"
                  onChange={onChange}
                  value={_.get(formData, 'mothers_middle_name') || ''}
                />
              </div>
              <div className="col-6 form-group">
                <label htmlFor="last_name" className="form-label mb-1">
                  Mother&apos;s Last Name &nbsp;{' '}
                  {validateForm.renderMessage('mothers_last_name')}
                </label>
                <input
                  className="form-control text-uppercase"
                  type="text"
                  name="mothers_last_name"
                  onChange={onChange}
                  value={_.get(formData, 'mothers_last_name') || ''}
                />
              </div>
              <div className="col-6 form-group">
                <label htmlFor="last_name" className="form-label mb-1">
                  Mother&apos;s Extension Name
                </label>
                <Select
                  className="extension_select w-100"
                  options={c.EXTENSION_NAMES}
                  onChange={(e) =>
                    handleOnChangeSelect(e, 'mothers_extension_name')
                  }
                  value={
                    c.EXTENSION_NAMES.find(
                      (x) =>
                        x.value === _.get(formData, 'mothers_extension_name')
                    ) || null
                  }
                />
                {/* <input
                  className="form-control text-uppercase"
                  type="text"
                  name="mothers_extension_name"
                  onChange={onChange}
                  value={_.get(formData, 'mothers_extension_name') || ''}
                /> */}
              </div>
            </div>
          </div>
        </div>

        <div className="d-flex justify-content-center">
          <button
            disabled={creating || updating || syncing}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3"
          >
            <span className="font-weight-bold">
              {creating || updating || syncing ? (
                <i className="fa fa-spin fa-spinner" />
              ) : (
                `Submit`
              )}
            </span>
          </button>
          <button
            disabled={creating || updating || syncing}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

BirthCertModal.defaultProps = {
  recordData: undefined,
};

BirthCertModal.propTypes = {
  getBirthCertificateList: PropTypes.instanceOf(Function).isRequired,
  createBirthCertificate: PropTypes.instanceOf(Function).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  showBirthCertificate: PropTypes.instanceOf(Function).isRequired,
  getRoleList: PropTypes.instanceOf(Function).isRequired,
  creating: PropTypes.bool.isRequired,
  recordData: PropTypes.instanceOf(Object),
  updating: PropTypes.bool.isRequired,
  syncing: PropTypes.bool.isRequired,
  syncToEs: PropTypes.instanceOf(Function).isRequired,
  updateBirthCertificate: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  regionsList: _.get(api, `${c.GET_REGION}.list`) || [],
  provinceList: _.get(api, `${c.GET_PROVINCE}.list`) || [],
  municipalityList: _.get(api, `${c.GET_MUNICIPALITIES}.list`) || [],
  barangayList: _.get(api, `${c.GET_BARANGAYS}.list`) || [],
  creating: api.loading.indexOf(c.CREATE_USER_MANAGEMENT) > -1,
  updating: api.loading.indexOf(c.UPDATE_USER_MANAGEMENT) > -1,
  syncing: api.loading.indexOf(c.SYNC_TO_ES) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, actions),
]);

export default enhance(BirthCertModal);
